import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskSearch, TaskSearchFilter, TaskSearchMatch } from '../task/task-search';
import { TaskSearchService } from '../task/task-search.service';

import { Message, ConfirmationService, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'pl-task-search',
  templateUrl: './task-search.component.html',
  styleUrls: ['./task-search.component.css'],
  providers: [ConfirmationService]
})
export class TaskSearchComponent implements OnInit {

  taskSearchList: TaskSearch[];
  msgs: Message[];
  selectedTaskSearch: TaskSearch;
  selectedTaskSearchFilter: TaskSearchFilter;
  selectedTaskSearchMatch: TaskSearchMatch;

  comparators: SelectItem[];
  fieldsUser: SelectItem[];
  fieldsTasks : SelectItem[];

  constructor(private taskSearchService: TaskSearchService, private router: Router,
    private confirmationService: ConfirmationService) {
    this.taskSearchList = [];
    this.msgs = [];
    this.comparators = [];
    this.fieldsUser = [];
    this.fieldsTasks = [];
    this.selectedTaskSearch = this.createDefaultTaskSearch();
  }

  ngOnInit() {
    this.loadComparableFields();
    this.loadComparableTaskFields();
    this.loadComparators();
    this.loadTaskSearchs();
  }

  private loadComparableFields() {
    this.fieldsUser = [];
    this.fieldsUser.push({ value: 'user.email', label: 'E-Mail' });
    this.fieldsUser.push({ value: 'user.forname', label: 'Vorname' });
    this.fieldsUser.push({ value: 'user.name', label: 'Name' });
    this.fieldsUser.push({ value: 'user.street', label: 'Strasse' });
    this.fieldsUser.push({ value: 'user.zip', label: 'PLZ' });
    this.fieldsUser.push({ value: 'user.town', label: 'Stadt' });
    this.fieldsUser.push({ value: 'user.country', label: 'Land' });
    this.fieldsUser.push({ value: 'user.property1', label: 'Eigenschaft 1' });
    this.fieldsUser.push({ value: 'user.property2', label: 'Eigenschaft 2' });
    this.fieldsUser.push({ value: 'user.property3', label: 'Eigenschaft 3' });
    this.fieldsUser.push({ value: 'user.property4', label: 'Eigenschaft 4' });
    /*this.fieldsReceipt.push({ value: 'receipt.receipt', label: 'WE-Nr' });
    this.fieldsReceipt.push({ value: 'receipt.hint', label: 'Lieferhinweis' });
    this.fieldsReceipt.push({ value: 'receipt.gate', label: 'Tor' });
    this.fieldsReceipt.push({ value: 'receipt.state', label: 'WE-Status' });
    this.fieldsReceipt.push({ value: 'receiptpos.pos', label: 'WE-Pos.' });
    this.fieldsReceipt.push({ value: 'receiptpos.qtyExpected', label: 'Menge Soll' });
    this.fieldsReceipt.push({ value: 'receiptpos.qtyReceived', label: 'Menge Ist' });
    this.fieldsReceipt.push({ value: 'receiptpos.reservationCode', label: 'Reservierungscode' });
    this.fieldsReceipt.push({ value: 'receiptpos.state', label: 'Pos. Status' });
    this.fieldsReceipt.push({ value: 'article.articleNumber', label: 'Artikelnr.' });
    this.fieldsReceipt.push({ value: 'article.base.unit', label: 'Basiseinheit' });
    this.fieldsReceipt.push({ value: 'article.receipt.unit', label: 'Liefereinheit' });
    this.fieldsReceipt.push({ value: 'article.receipt.baseFactor', label: 'Liefereinheitfaktor.' });
    this.fieldsReceipt.push({ value: 'article.weight', label: 'Artikel-Gewicht' });
    this.fieldsReceipt.push({ value: 'article.serialNumber', label: 'Seriennr.-KNZ' });
    this.fieldsReceipt.push({ value: 'article.charge', label: 'Charge-KNZ' });
    this.fieldsReceipt.push({ value: 'article.pickable', label: 'Kommissionierbar-KNZ' });
    this.fieldsReceipt.push({ value: 'article.name1', label: 'Artikelbez. 1' });
    this.fieldsReceipt.push({ value: 'article.name2', label: 'Artikelbez. 2' });
    this.fieldsReceipt.push({ value: 'article.name3', label: 'Artikelbez. 3' });
    this.fieldsReceipt.push({ value: 'article.name4', label: 'Artikelbez. 4' });
    this.fieldsReceipt.push({ value: 'article.descr', label: 'Artikelbeschreibung' });*/
  }

  private loadComparableTaskFields() {
    this.fieldsTasks = [];
    this.fieldsTasks.push({ value: 'priority', label: 'Prio.' });
    this.fieldsTasks.push({ value: 'active_userid', label: 'Active User' });
    this.fieldsTasks.push({ value: 'state', label: 'Status' });
    this.fieldsTasks.push({ value: 'type', label: 'Typ' });
    this.fieldsTasks.push({ value: 'bin.bintype.name', label: 'Beh. Typ. Name' });
    this.fieldsTasks.push({ value: 'bin.bintype.shortname', label: 'Beh.-Typ.-Kurzname' });
    this.fieldsTasks.push({ value: 'bin.bintype.height', label: 'Beh.-Typ.-Hoehe' });
    this.fieldsTasks.push({ value: 'bin.bintype.width', label: 'Beh.-Typ.-Breite' });
    this.fieldsTasks.push({ value: 'bin.bintype.length', label: 'Beh.-Typ.-Laenge' });
    this.fieldsTasks.push({ value: 'bin.bintype.weight', label: 'Beh.-Typ.-Gewicht' });
    this.fieldsTasks.push({ value: 'bin.bintype.relativeSize', label: 'Beh.-Typ. relative Groesse' });
    this.fieldsTasks.push({ value: 'bin.weight', label: 'Beh. Gewicht' });
    this.fieldsTasks.push({ value: 'bin.barcode', label: 'Beh. Barcode' });
    this.fieldsTasks.push({ value: 'sourceLocation.area.name', label: 'Quelle - Bereichsname' });
    this.fieldsTasks.push({ value: 'sourceLocation.area.shortname', label: 'Quelle - Bereichskurzname' });
    this.fieldsTasks.push({ value: 'sourceLocation.area.prefix', label: 'Quelle - Bereichsprefix' });
    this.fieldsTasks.push({ value: 'sourceLocation.locationType.name', label: 'Quelle - Platz-Typ: Name' });
    this.fieldsTasks.push({ value: 'sourceLocation.locationType.picking', label: 'Quelle - Platz-Typ: Kommissionierung' });
    this.fieldsTasks.push({ value: 'sourceLocation.locationType.transport', label: 'Quelle - Platz-Typ: Transporte' });
    this.fieldsTasks.push({ value: 'sourceLocation.locationType.compact', label: 'Quelle - Platz-Typ: Verdichten' });
    this.fieldsTasks.push({ value: 'sourceLocation.locationType.inbound', label: 'Quelle - Platz-Typ: WE-Zone' });
    this.fieldsTasks.push({ value: 'sourceLocation.locationType.outbound', label: 'Quelle - Platz-Typ: WA-Zone' });
    this.fieldsTasks.push({ value: 'sourceLocation.locationType.count', label: 'Quelle - Platz-Typ: Kapazitaet' });
    this.fieldsTasks.push({ value: 'sourceLocation.barcode', label: 'Quelle - Barcode' });
    this.fieldsTasks.push({ value: 'sourceLocation.capacityUsed', label: 'Quelle - Kapazität (belegt)' });
    this.fieldsTasks.push({ value: 'sourceLocation.capacityFree', label: 'Quelle - Kapazität (frei)' });
    this.fieldsTasks.push({ value: 'sourceLocation.capacityMax', label: 'Quelle - Kapazität (max)' });
    this.fieldsTasks.push({ value: 'sourceLocation.loadUsed', label: 'Quelle - Tragkraft (belegt)' });
    this.fieldsTasks.push({ value: 'sourceLocation.loadFree', label: 'Quelle - Tragkraft (frei)' });
    this.fieldsTasks.push({ value: 'sourceLocation.loadMax', label: 'Quelle - Tragkraft (max)' });
    this.fieldsTasks.push({ value: 'destinationLocation.area.name', label: 'Ziel - Bereichsname' });
    this.fieldsTasks.push({ value: 'destinationLocation.area.shortname', label: 'Ziel - Bereichskurzname' });
    this.fieldsTasks.push({ value: 'destinationLocation.area.prefix', label: 'Ziel - Bereichsprefix' });
    this.fieldsTasks.push({ value: 'destinationLocation.locationType.name', label: 'Ziel - Platz-Typ: Name' });
    this.fieldsTasks.push({ value: 'destinationLocation.locationType.picking', label: 'Ziel - Platz-Typ: Kommissionierung' });
    this.fieldsTasks.push({ value: 'destinationLocation.locationType.transport', label: 'Ziel - Platz-Typ: Transporte' });
    this.fieldsTasks.push({ value: 'destinationLocation.locationType.compact', label: 'Ziel - Platz-Typ: Verdichten' });
    this.fieldsTasks.push({ value: 'destinationLocation.locationType.inbound', label: 'Ziel - Platz-Typ: WE-Zone' });
    this.fieldsTasks.push({ value: 'destinationLocation.locationType.outbound', label: 'Ziel - Platz-Typ: WA-Zone' });
    this.fieldsTasks.push({ value: 'destinationLocation.locationType.count', label: 'Ziel - Platz-Typ: Kapazitaet' });
    this.fieldsTasks.push({ value: 'destinationLocation.barcode', label: 'Ziel - Barcode' });
    this.fieldsTasks.push({ value: 'destinationLocation.capacityUsed', label: 'Ziel - Kapazität (belegt)' });
    this.fieldsTasks.push({ value: 'destinationLocation.capacityFree', label: 'Ziel - Kapazität (frei)' });
    this.fieldsTasks.push({ value: 'destinationLocation.capacityMax', label: 'Ziel - Kapazität (max)' });
    this.fieldsTasks.push({ value: 'destinationLocation.loadUsed', label: 'Ziel - Tragkraft (belegt)' });
    this.fieldsTasks.push({ value: 'destinationLocation.loadFree', label: 'Ziel - Tragkraft (frei)' });
    this.fieldsTasks.push({ value: 'destinationLocation.loadMax', label: 'Ziel - Tragkraft (max)' });
  }

  private loadComparators() {
    this.comparators = [];
    this.comparators.push({ value: '=', label: '=' });
    this.comparators.push({ value: '!=', label: '!=' });
    this.comparators.push({ value: '>', label: '>' });
    this.comparators.push({ value: '<', label: '<' });
    this.comparators.push({ value: '>=', label: '>=' });
    this.comparators.push({ value: '<=', label: '<=' });
    this.comparators.push({ value: 'startsWith', label: 'Beginnt mit' });
    this.comparators.push({ value: 'endsWith', label: 'Ended mit' });
    this.comparators.push({ value: 'contains', label: 'Beinhaltet' });
    this.comparators.push({ value: 'notStartsWith', label: 'Beginnt nicht mit' });
    this.comparators.push({ value: 'notEndsWith', label: 'Ended nicht mit' });
    this.comparators.push({ value: 'notContains', label: 'Beinhaltet nicht' });
  }

  private loadTaskSearchs() {
    console.log("Load TaskSearches...");
    this.taskSearchService.list().subscribe(
      (taskSearchArray: TaskSearch[]) => {
        this.taskSearchList = [];
        this.selectedTaskSearch = this.createDefaultTaskSearch();
        this.selectedTaskSearchFilter = null;
        this.selectedTaskSearchMatch = null;
        for (var taskSearch of taskSearchArray)
          this.taskSearchList = [...this.taskSearchList, taskSearch];
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of taskSearchs.' });
      }
    );
  }

  private createDefaultTaskSearch(): TaskSearch {
    let taskSearch = new TaskSearch();
    taskSearch.id = -1;

    taskSearch.descr = "";
    taskSearch.name = "";
    taskSearch.priority = 99;
    taskSearch.task = "";

    taskSearch.filters = [];
    taskSearch.matches = [];

    taskSearch.created = new Date();
    taskSearch.updated = new Date();
    return taskSearch;
  }

  public addNew() {
    console.log('Create new TaskSearch.');

    /**
     * We need to check first, if there is already a new instance
     * in list of areas.
     */
    for (var a of this.taskSearchList) {
      if (a.id < 0) {
        this.selectedTaskSearch = a;
        this.msgs.push({ severity: 'info', summary: 'Erst neuen Platz speichern.' });
        return;
      }
    }

    let taskSearch = this.createDefaultTaskSearch();

    this.taskSearchList = [...this.taskSearchList, taskSearch];
    this.selectedTaskSearch = taskSearch;
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
  }

  public deleteSelected() {
    console.log("Delete task type triggered");
    this.msgs = [];
    if (this.selectedTaskSearch == null) {
      console.log("No task type selected -> return");
      this.msgs.push({ severity: 'info', summary: 'Keine Strategie ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie die Strategie wirlich loeschen?',
      accept: () => {
        this.taskSearchService.delete(this.selectedTaskSearch.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Strategie wurde geloescht.' });
              this.loadTaskSearchs();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Strategie konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Strategie konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited taskSearch entity to server.
   */
  public onSave() {
    if (this.selectedTaskSearch == null || this.selectedTaskSearch.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an taskSearch first.' });

    if (this.selectedTaskSearch.id == -1) {
      this.taskSearchService.save(this.selectedTaskSearch).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Die Strategie wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadTaskSearchs();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Die Strategie konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save taskSearch, error msg: ' + err);
        }
      );
    }
    else {
      this.taskSearchService.update(this.selectedTaskSearch).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Die Strategie wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadTaskSearchs();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Die Strategie konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save taskSearch, error msg: ' + err);
        }
      );
    }
  }


  /**
   * Helper function to edit filters and matches
   */
  public addFilter() {
    console.log('Add filter triggered.');
    if (this.selectedTaskSearch != null) {
      let filter: TaskSearchFilter = new TaskSearchFilter();
      filter.id = 0;
      filter.comparator = '=';
      filter.field = this.fieldsTasks[0].value;
      filter.expression = '';
      filter.created = new Date();

      this.selectedTaskSearch.filters = [...this.selectedTaskSearch.filters, filter];
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst eine Strategie auswählen.' });
    }
  }

  public addMatch() {
    console.log('Add match triggered.');
    if (this.selectedTaskSearch != null) {
      let match: TaskSearchMatch = new TaskSearchMatch();
      match.id = 0;
      match.comparator = '=';
      match.field = this.fieldsUser[0].value;
      match.expression = '';
      match.created = new Date();

      this.selectedTaskSearch.matches = [...this.selectedTaskSearch.matches, match];
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst eine Strategie auswählen.' });
    }
  }

  public deleteSelectedFilter() {
    if (this.selectedTaskSearchFilter != null) {
      let filters: TaskSearchFilter[] = [];
      for (var filter of this.selectedTaskSearch.filters) {
        if(!this.compareFilter(filter,this.selectedTaskSearchFilter))
          filters.push(filter);
      }
      this.selectedTaskSearch.filters = filters;
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst einen Filter auswählen.' });
    }
  }

  public deleteSelectedMatch() {
    if (this.selectedTaskSearchMatch != null) {
      let matches: TaskSearchMatch[] = [];
      for (var match of this.selectedTaskSearch.matches) {
        if(!this.compareMatch(match,this.selectedTaskSearchMatch))
        matches.push(match);
      }
      this.selectedTaskSearch.matches = matches;
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst einen Filter auswählen.' });
    }
  }

  private compareFilter(o1: TaskSearchFilter, o2: TaskSearchFilter): boolean {
    if (o1.comparator === o2.comparator &&
      o1.expression === o2.expression &&
      o1.field === o2.field &&
      o1.id === o2.id) {
      return true;
    } else {
      return false;
    }
  }

  private compareMatch(o1: TaskSearchMatch, o2: TaskSearchMatch): boolean {
    if (o1.comparator === o2.comparator &&
      o1.expression === o2.expression &&
      o1.field === o2.field &&
      o1.id === o2.id) {
      return true;
    } else {
      return false;
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/task-search/task-search.component.ts